import { Button } from "../../../components/ui/button"

interface SectionProps {
  id: string
  children: React.ReactNode
}

export default function SectionWrapper({ id, children }: SectionProps) {
  return (
    <section id={id} className="mb-12 p-8 bg-white rounded-lg shadow-lg">
      {children}

      {id !== "introduction" && (
        <div className="flex justify-center mt-8">
          <Button variant="default" asChild>
            <a href="#table-of-contents">Back to Quick Start</a>
          </Button>
        </div>
      )}
    </section>
  )
}
